

































































import { Box, SecondaryButton, Button, Flex, BaseModal, InputError } from '../../atoms'
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { InputGroup, PasswordInputGroup } from '../../molecules'
import { mapActions } from 'vuex'
import { passwordRequired, passwordMinLength, passwordMismatch, newPasswordMismatch, wrongPasswordPattern } from '../../../utils/errors'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import { passwordPattern } from '../../../utils/validators'
import { PROFILE_MODULE, CHANGE_PASSWORD } from '../../../store/modules/profile/constant'

@Component({
  components: {
    Box,
    Flex,
    InputGroup,
    SecondaryButton,
    Button,
    BaseModal,
    PasswordInputGroup,
    InputError
  },
  methods: {
    ...mapActions(PROFILE_MODULE, [CHANGE_PASSWORD])
  },
  validations: {
    oldPassword: {
      required
    },
    newPassword: {
      required,
      minLength: minLength(8),
      passwordPattern
    },
    repeatPassword: {
      required,
      sameAsPassword: sameAs('newPassword')
    }
  }
})
export default class ChangePasswordBox extends Vue {
  @Prop({ required: false, type: Array }) readonly providers!: any
  showBox = false
  modalVisible = false
  oldPassword = ''
  newPassword = ''
  repeatPassword = ''
  errorMsg = ''
  errorOldPassword = ''
  errorNewPassword = ''
  errorRepeatPassword = ''
  modalVisibleSuccess = false

  @Watch('providers')
  checkEmailProvider() {
    for (const q of this.providers) {
      if (q.provider == 'email') {
        this.showBox = true
      }
    }
  }

  @Watch('modalVisible')
  onModalVisibilityChange() {
    if (this.modalVisible) {
      this.$nextTick(() => {
        this.$v.$reset()
      })
    }
  }
  @Watch('oldPassword')
  onOldPasswordChange() {
    this.errorMsg = ''
    this.$v.oldPassword.$touch()
  }
  @Watch('newPassword')
  onPasswordChange() {
    this.errorMsg = ''
    this.$v.newPassword.$touch()
  }
  @Watch('repeatPassword')
  onRepeatPassword() {
    this.errorMsg = ''
    this.$v.repeatPassword.$touch()
  }

  onClose(): void {
    this.clearValue()
    this.modalVisible = !this.modalVisible
  }
  onCloseSuccess(): void {
    this.modalVisibleSuccess = !this.modalVisibleSuccess
  }
  get formError(): boolean {
    this.$v.oldPassword.$touch()
    this.$v.newPassword.$touch()
    this.$v.repeatPassword.$touch()
    return this.oldPasswordError == '' && this.newPasswordError == '' && this.repeatPasswordError == ''
  }
  async submitChangePassword() {
    if (!this.formError) {
      return
    }
    const password = {
      old_password: this.oldPassword,
      password: this.newPassword,
      repeat_password: this.repeatPassword
    }

    const resp = await (this as any)[CHANGE_PASSWORD](password)
    if (resp.code === 200) {
      this.clearValue()
      this.modalVisible = !this.modalVisible
      this.modalVisibleSuccess = !this.modalVisibleSuccess
    } else {
      this.errorMsg = resp?.error_message
    }
  }
  clearValue(): void {
    this.oldPassword = ''
    this.newPassword = ''
    this.repeatPassword = ''
  }
  get oldPasswordError(): string {
    const { oldPassword } = this.$v
    if (oldPassword.$error) {
      if (!oldPassword.required) {
        this.errorOldPassword = passwordRequired
        return passwordRequired
      }
      if (!oldPassword.minLength) {
        return passwordMinLength
      }
    }
    return ''
  }

  get newPasswordError(): string {
    const { newPassword } = this.$v
    if (newPassword.$error) {
      if (!newPassword.required) {
        this.errorNewPassword = passwordRequired
        return passwordRequired
      }
      if (!newPassword.minLength) {
        this.errorNewPassword = passwordMinLength
        return passwordMinLength
      }
      if (!newPassword.passwordPattern) {
        this.errorNewPassword = wrongPasswordPattern
        return wrongPasswordPattern
      }
    }
    return ''
  }
  get repeatPasswordError(): string {
    const { repeatPassword } = this.$v
    if (repeatPassword.$error) {
      if (!repeatPassword.required) {
        this.errorRepeatPassword = passwordRequired
        return passwordRequired
      }
      if (!repeatPassword.sameAsPassword) {
        this.errorRepeatPassword = passwordMismatch
        return newPasswordMismatch
      }
    }
    return ''
  }
}
